import { render, staticRenderFns } from "./OptometryApppointmentTable.vue?vue&type=template&id=d40df1f4&"
import script from "./OptometryApppointmentTable.vue?vue&type=script&lang=js&"
export * from "./OptometryApppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports